import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'
import { Button, Spinner } from '../../components'
import { connectRedux } from '../../helpers/connectRedux'
import { images } from '../../images'
import { LiteralsService } from '../../services'
import { setSignUpTermsAndConditionsAction, signUpAction } from '../../store/actions'
import { IStoreState } from '../../store/states'
import TermsAndConditionsText, { privacyUrl, termsUrl } from '../TermsAndConditionsText'

interface IProps extends DispatchProp<AnyAction> {
  language: string
  termsAndConditions: boolean
  isSigningUp: boolean
}

/**
 * Last step of the sign up — the terms and the actual registration — shared by the page and
 * the guest prompt. Where it leads afterwards is the sign up saga's business (verification).
 */
class SignUpStep3Form extends PureComponent<IProps> {
  private get buttonIsDisabled(): boolean {
    const { termsAndConditions, isSigningUp } = this.props
    return !termsAndConditions || isSigningUp
  }

  private get signUpButton(): ReactNode {
    const { isSigningUp } = this.props
    if (isSigningUp) return <div className="loading"><Spinner /></div>
    return (
      <Button
        title={ LiteralsService.get('finalize') }
        onPress={ this.validation }
        filled
        upper
        isDisabled={ this.buttonIsDisabled }
      />
    )
  }

  private get termsCheckbox(): ReactNode {
    const { termsAndConditions } = this.props

    const checkbox = termsAndConditions
      ? <img onClick={ this.onTermsAndConditionsChange } src={ images['checkBoxFilled'] } alt="AMB:Bus Metropolità"/>
      : <img onClick={ this.onTermsAndConditionsChange } src={ images['checkBoxEmpty'] } alt="AMB:Bus Metropolità"/>

    return (
      <div className="checkbox">
        { checkbox }
        { this.acceptance }
      </div>
    )
  }

  // "I have read and accept the privacy policy and terms and conditions", both linked, as on the
  // app. Basque puts the verb after the links, so there the sentence starts with them.
  private get acceptance(): ReactNode {
    const isBasque = LiteralsService.isLanguageActive('eu')

    return (
      <span>
        { !isBasque && LiteralsService.get('termsAndConditionsNoLink', true) + ' ' }
        <a className="link" href={ privacyUrl() } target="_blank" rel="noopener noreferrer">
          { LiteralsService.get('linkPrivacyPolicy') }
        </a>
        { ' ' + LiteralsService.get('and') + ' ' }
        <a className="link" href={ termsUrl() } target="_blank" rel="noopener noreferrer">
          { LiteralsService.get('linkTermsAndConditions') }
        </a>
        { isBasque && ' ' + LiteralsService.get('termsAndConditionsNoLink') }
      </span>
    )
  }

  public render(): ReactNode {
    return (
      <>
        <section>
          { /* The legal text itself, in a scrollable box above the acceptance, as on the app. */ }
          <div className="terms-text">
            <TermsAndConditionsText />
          </div>
          { this.termsCheckbox }
        </section>
        <section className="actions">
          { this.signUpButton }
        </section>
      </>
    )
  }

  private onTermsAndConditionsChange = (): void => {
    this.props.dispatch(setSignUpTermsAndConditionsAction())
  }

  private validation = (): void => {
    this.props.dispatch(signUpAction())
  }
}

const mapStateToProps = ({ signUp, configuration }: IStoreState) => ({
  language: configuration.language,
  termsAndConditions: signUp.termsAndConditions,
  isSigningUp: signUp.isSigningUp
})

export default connectRedux(mapStateToProps, SignUpStep3Form) as React.ComponentType<{}>
